<template>
    <div>
        <navigation></navigation>
        <h2>Sorry, I couldn't find what you were looking for.</h2>
    </div>
</template>

<script>
    export default {
        name: 'NotFound',
        data () {
            return {};
        }
    };
</script>

<style lang="postcss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/not-found/not-found.vue